import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import * as Helpers from "../helpers";

var RentIncreaseHelper =
/*#__PURE__*/
function () {
  function RentIncreaseHelper() {
    _classCallCheck(this, RentIncreaseHelper);

    _defineProperty(this, "RENTINCREASETYPES", {
      AUTO: {
        label: "Auto",
        value: 1
      },
      BUDGET: {
        label: "Budget",
        value: 2
      },
      ELDERLY: {
        label: "Elderly",
        value: 3
      }
    });
  }

  _createClass(RentIncreaseHelper, [{
    key: "requestRentValidation",
    value: function requestRentValidation(rentIncreaseTypeId, val) {
      if (rentIncreaseTypeId == this.RENTINCREASETYPES.AUTO.value || rentIncreaseTypeId == this.RENTINCREASETYPES.ELDERLY.value) {
        if (((val.requestedRents - val.currentRents) / val.currentRents * 100).toFixed(4) <= val.suggestedIncreasePercent || this.isAdmin) {
          val.percentIncrease = Helpers.NumberHelper.RoundUpToTheNearest(((val.requestedRents - val.currentRents) / val.currentRents * 100).toFixed(4), 0.5);
          return true;
        }

        return false;
      } else {
        if (((val.requestedRents - val.currentRents) / val.currentRents * 100).toFixed(4) <= val.maxRentIncreasePercent || this.isAdmin) {
          val.percentIncrease = Helpers.NumberHelper.RoundUpToTheNearest(((val.requestedRents - val.currentRents) / val.currentRents * 100).toFixed(4), 0.5);
          return true;
        }

        return false;
      }
    }
  }, {
    key: "calculateRequestedRentIncrease",
    value: function calculateRequestedRentIncrease(val) {
      val.requestedRents = Math.ceil((val.currentRents * parseFloat(val.percentIncrease) * 0.01 + val.currentRents).toFixed(4));

      while (((val.requestedRents - val.currentRents) / val.currentRents * 100).toFixed(4) > val.percentIncrease) {
        val.requestedRents--;
      }

      return val.requestedRents;
    }
  }, {
    key: "calculatePercentage",
    value: function calculatePercentage(val) {
      return ((val.requestedRents - val.currentRents) / val.currentRents * 100).toFixed(4);
    }
  }]);

  return RentIncreaseHelper;
}();

export default new RentIncreaseHelper();